import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@reach/router';
import { State, SessionState } from 'types';
import { Box, LoginPopover } from 'components';

import Profile from './Profile';
import styles from './AccountHeader.less';

type OwnProps = {
  /**
   * URL for the site's homepage. This determines where the user is taken if they
   * click the logo on the left of the header. If this isn't provided, then the
   * logo will not be clickable.
   */
  homeUrl?: string;

  practiceId: number;

  /**
   * Content to render in the right of the header. This will override the default
   * login icon/dropdown if provided.
   */
  rightContent?: React.ReactNode;
};

type StateProps = {
  session: SessionState;
};

type Props = OwnProps & StateProps;

const mapStateToProps = (state: State): StateProps => ({
  session: state.session,
});

const AccountHeader: React.FC<Props> = ({
  homeUrl,
  practiceId,
  rightContent: baseRightContent,
  session,
}) => {
  let rightContent;
  if (baseRightContent) {
    rightContent = baseRightContent;
  } else if (session.activeUserId) {
    rightContent = <Profile />;
  } else {
    rightContent = (
      <LoginPopover forceChartSelection practiceId={practiceId}>
        <img className={styles.profile} src="/static/images/booking/person.svg" alt="Log-in" />
      </LoginPopover>
    );
  }

  return (
    <Box className={styles.header} justify="space-between">
      {homeUrl ? (
        <Link to={homeUrl}>
          <img src="/static/images/booking/logo.svg" className={styles.logo} alt="ElationHealth" />
        </Link>
      ) : (
        <img src="/static/images/booking/logo.svg" className={styles.logo} alt="ElationHealth" />
      )}
      {rightContent}
    </Box>
  );
};

export default connect(mapStateToProps)(AccountHeader);
